import MemoryStorage from './memoryStorage';

type storageType = 'localStorage' | 'sessionStorage';

export function testStorage(type: storageType) {
  try {
    const storage: Storage = window[type];
    try {
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }
  } catch (error) {
    return false;
  }
}

// wrapper for storage->JSON
export class JsonStorage {
  private ls: Storage;

  constructor(storage: storageType) {
    if (storage && testStorage(storage)) {
      this.ls = window[storage];
    } else {
      this.ls = new MemoryStorage();
    }
  }

  public load = <T = any>(key: string) => {
    const result = this.ls.getItem(key) || 'null';
    return JSON.parse(result) as T | null;
  };

  public save = <T = any>(key: string, value?: T) => {
    return this.ls.setItem(key, JSON.stringify(value || null));
  };

  public remove = (key: string) => {
    return this.ls.removeItem(key);
  };

  public clear = () => {
    return this.ls.clear();
  };
}

export const localStorage = new JsonStorage('localStorage');

export const sessionStorage = new JsonStorage('sessionStorage');
